import PropTypes from "prop-types";

import { Grid, makeStyles } from "../../utils/barrels/material-ui-core";

const styles = {
	grid: {
		margin: "0 -15px",
		width: "calc(100% + 30px)",
	},
};

const useStyles = makeStyles(styles);

export default function GridContainer(props) {
	const classes = useStyles();
	const { children, className, justify, ...rest } = props;
	return (
		<Grid
			container
			{...rest}
			justifyContent={justify ?? rest.justifyContent}
			className={`${classes.grid} ${className}`}
		>
			{children}
		</Grid>
	);
}

GridContainer.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};
